var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"formCont",attrs:{"id":"cfgHyuSubmitForm","action":_vm.dataBO.form.formUrl,"method":"post"}},_vm._l((_vm.getFormFields),function(field,i){return _c('input',{key:i,attrs:{"type":"hidden","name":field.name,"id":field.name},domProps:{"value":field.value}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }